// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c1c399ad","239":"ec0ee434","455":"5b905680"}[chunkId] + ".chunk.js";
};